import OpenXLogo from './assets/logo_color.svg?url';
import OpenXLogoWhite from './assets/logo_white.svg?url';

export interface LogoProps {
  ['data-test']?: string;
  invertColors?: boolean;
}

export function Logo(props: Readonly<LogoProps>): JSX.Element {
  const { invertColors } = props;

  if (invertColors) {
    return <img src={OpenXLogoWhite} data-test={props['data-test']} style={{ height: '26px' }} alt="OpenX Logo" />;
  }
  return <img src={OpenXLogo} data-test={props['data-test']} style={{ height: '26px' }} alt="OpenX Logo" />;
}
